import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { Card, Col, Row, Tabs, Tab } from 'react-bootstrap';

import { fetchEmetScoreSheetByCertification } from 'api/certifications/emet/results';

import { handleApiError } from 'utils';

import styles from './epstEvaluation.module.scss';
import Questions from './Questions';


const ViewEmet = () => {
	const token = useSelector(state => state.authentication.user?.token);

	const location = useLocation();
	const navigate = useNavigate();
	const { certification } = location.state || {};

	
	const [sectionOne, setSectionOne] = useState([]); 
	const [sectionTwo, setSectionTwo] = useState([]); 
	const [sectionThree, setSectionThree] = useState([]); 
	const [sectionFour, setSectionFour] = useState([]);

	const [activeTab, setActiveTab] = useState("sectionOne");


	useEffect(() => {
		if (!certification.id) navigate(-1);
		else {
			loadCertificationByIdSectionId(1);
			loadCertificationByIdSectionId(2);
			loadCertificationByIdSectionId(3); 
			loadCertificationByIdSectionId(4);
		}
	}, [certification, navigate]);

	const loadCertificationByIdSectionId = async (sectionId) => {
		try {
			const { data } = await fetchEmetScoreSheetByCertification(certification.id, sectionId, token);;
			if(sectionId === 1) setSectionOne(data.message);
			if(sectionId === 2) setSectionTwo(data.message);
			if(sectionId === 3) setSectionThree(data.message);
			if(sectionId === 4) setSectionFour(data.message);
		} catch (error) {
			handleApiError(error);
		}
	}


	return (
		<Card>
			<Card.Body className="overflow-hidden p-lg-5">
				<h5 className="text-primary">Ver Examen</h5>

				{/* Información general */}
				<Row className="mt-3">
					{/* Columna izquierda */}
					<Col xs={12} md={6}>
						<p className={styles.rowUserData}>
							<strong>Nombre:</strong> {certification.name}
						</p>
						<p className={styles.rowUserData}>
							<strong>Email:</strong> {certification.email}
						</p>
						<p className={styles.rowUserData}>
							<strong>Colegio:</strong> {certification.college_name}
						</p>
					</Col>

					{/* Columna derecha */}
					<Col xs={12} md={6}>
						<p className={styles.rowUserData}>
							<strong>Nivel:</strong> {certification.level}
						</p>
						<p className={styles.rowUserData}>
							<strong>Tipo certificación:</strong> {certification.certification_type}
						</p>
						<p className={styles.rowUserData}>
							<strong>Fecha finalizado:</strong> {certification.completed_date}
						</p>
					</Col>
				</Row>
				{/* Tabs para cada seccion */}
				<Tabs 
					defaultActiveKey="sectionOne"
					activeKey={activeTab}
					onSelect={(k) => setActiveTab(k)}
					className="mb-3 mt-3">
					{/* Grammar Tab */}
					<Tab eventKey="sectionOne" title="Section 1" className="p-3">
						{sectionOne.length === 0 ? (
							<Row><Col>No hay respuestas para esta sección.</Col></Row>
						) : (
							<>
								{sectionOne.map(question => (
									<Questions
										key={question.question_id}
										questionData={question}
									/>
								))}
							</>
						)}
					</Tab>

					<Tab eventKey="sectionTwo" title="Section 2" className="p-3">
						{sectionTwo.length === 0 ? (
							<Row><Col>No hay respuestas para esta sección.</Col></Row>
						) : (
							<>
								{sectionTwo.map(question => (
									<Questions
										key={question.question_id}
										questionData={question}
									/>
								))}
							</>
						)}
					</Tab>

					<Tab eventKey="sectionThree" title="Section 3" className="p-3">
						{sectionThree.length === 0 ? (
							<Row><Col>No hay respuestas para esta sección.</Col></Row>
						) : (
							<>
								{sectionThree.map(question => (
									<Questions
										key={question.question_id}
										questionData={question}
									/>
								))}
							</>
						)}
					</Tab>
					
					<Tab eventKey="sectionFour" title="Section 4" className="p-3">
						{sectionFour.length === 0 ? (
							<Row><Col>No hay respuestas para esta sección.</Col></Row>
						) : (
							<>
								{sectionFour.map(question => (
									<Questions
										key={question.question_id}
										questionData={question}
									/>
								))}
							</>
						)}
					</Tab>

					
				</Tabs>
				<div className="d-flex justify-content-between" >
					<button className="btn btn-outline-secondary" onClick={() => navigate(-1)}>
						← Regresar
					</button>
				</div>

			</Card.Body>
		</Card>
	);
};

export default ViewEmet;